import React from 'react';
import { FaRegFolder } from 'react-icons/fa6';
import TitleEditor from '../Forms/TitleEditor';
import projectApi, { useUpdateProjectMutation } from '../../api/project';

interface ProjectTitleEditorProps {
    name: string;
    id: string;
    description?: string;
}

export default function ProjectTitleEditor(props: ProjectTitleEditorProps) {
    const [updateProject] = useUpdateProjectMutation();
    const { refetch } = projectApi.endpoints.listProjects.useQuerySubscription({});

    const handleUpdate = async (id: string, name: string) => {
        await updateProject({
            id,
            name,
            description: props.description // Include the existing description in the update
        }).unwrap();
    };

    return (
        <TitleEditor
            {...props}
            icon={FaRegFolder}
            titleType="project"
            onUpdate={handleUpdate}
            onRefetch={refetch}
        />
    );
}